/* eslint-disable react/jsx-no-target-blank */
import useIsMobile from 'utils/hooks/useIsMobile'
import {serverLocalName} from 'GLOBAL/envVariables'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'

import {useEffect} from 'react'
import {leakModelHandler, showHdmMenuHandler} from 'utils/const/globalController'
import {busanAlert} from 'utils/CustomAlert/Alert'
import {useAuth} from '../../../../_component/modules/auth'
import {
  asideAccountPath,
  asideChargePath,
  asideCustomerPath,
  asideDevicePath,
  asideInstallPath,
  asideMatchPath,
  asideSettingsPath,
  asideSystemPath,
  asideTaskPath,
} from './AsideMenuConst'
import {AsideMenuItem} from './AsideMenuItem'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import './asside.css'
// console.log(serverLocalName)

export function AsideMenuMain() {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/

  const intl = useIntl()
  const isMobile = useIsMobile()
  const {currentUser} = useAuth()
  const officeInfo = useSelector((state: any) => state.officeInfo)
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)

  const isShowHdmMenu = showHdmMenuHandler(serverLocalName, officeInfo?.value)

  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/

  useEffect(() => {
    // sys and 부산의 경우 alert 표기
    if (
      String(userInfo.accountType).includes('sys') &&
      String(officeInfo.value).slice(0, 2) === '13'
    ) {
      busanAlert()
    }
  }, [officeInfo.value])
  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/
  const chargeUserHandler = (serverName: string, officeValue: string) => {
    switch (serverName) {
      case 'cheonan':
        return true
      case 'dev':
      case 'prod':
        switch (officeValue) {
          case '19':
          case '1900':
            return true
          default:
            return false
        }
      default:
        return false
    }
  }

  const aSideMenuHandler = (type: any) => {
    switch (type) {
      case 'sys_admin':
        return (
          <>
            <AsideMenuItemWithSub
              to='/customer/*'
              title='수용가'
              icon='/media/icons/duotune/general/gen001.svg'
            >
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_REGISTER}
                title='수용가 등록 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_ALLOCATION}
                title='수용가 할당 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_INFO}
                title='수용가 정보관리'
                hasBullet={true}
              />

              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_BINARY_CHECK}
                title='검침 이미지 검증'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_FLAGGED_REVIEW}
                title='확인 필요 수용가'
                hasBullet={true}
              />

              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_ACTIVITY}
                title='건강 모니터링'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CHECKLIST}
                title='수용가 검침조회'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CHECK_REPORT}
                title='검침 리포트'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_MINIMUM_FLOW}
                title='최소유량 조회'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_STATUS}
                title='수용가 현황'
                hasBullet={true}
              />
              <AsideMenuItem to={asideCustomerPath.CUSTOMER_HDM} title='HDM' hasBullet={true} />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_LEAKAGE}
                title='누수의심 조회'
                hasBullet={true}
              />

              {leakModelHandler(serverLocalName, officeInfo.value) === '2' && (
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_UNUSED}
                  title='장기미사용 조회'
                  hasBullet={true}
                />
              )}
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_FREEZE_WARNING}
                title='동파위험 조회'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/device/*'
              title='단말기'
              icon='/media/icons/duotune/electronics/elc003.svg'
            >
              <AsideMenuItem
                to={asideDevicePath.DEVICE_REGISTER}
                title='단말기 등록 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_ALLOCATION}
                title='단말기 검수/할당 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_INFO}
                title='단말기 정보 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_IMAGES}
                title='단말기 수신영상 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_HISTORY}
                title='단말기 HISTORY'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/task/*'
              title='업무'
              icon='/media/icons/duotune/files/fil002.svg'
            >
              <AsideMenuItem to={asideTaskPath.TASK_AS} title='AS 관리' hasBullet={true} />
              <AsideMenuItem to={asideTaskPath.TASK_RECOVERY} title='회수 조회' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/account/*'
              title='계정관리'
              icon='/media/icons/duotune/communication/com006.svg'
            >
              <AsideMenuItem
                to={asideAccountPath.ACCOUNT_GROUP}
                title='사용자 계정관리'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/system/*'
              title='시스템'
              icon='/media/icons/duotune/coding/cod001.svg'
            >
              <AsideMenuItem
                to={asideSystemPath.SYSTEM_CODE}
                title='시스템 코드관리'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/match/*'
              title='매칭시스템'
              icon='/media/icons/duotune/coding/cod001.svg'
            >
              <AsideMenuItem to={asideMatchPath.MATCH_FOTA} title='FOTA연결' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/settings/*'
              title='설정'
              icon='/media/icons/duotune/general/gen003.svg'
            >
              <AsideMenuItem
                to={asideSettingsPath.SETTINGS_SETUP}
                title='사업소 기초설정'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/install/*'
              title='설치자 관리'
              icon='/media/icons/duotune/coding/cod009.svg'
            >
              <AsideMenuItem to={asideInstallPath.INSTALL_CONNECT} title='설치' hasBullet={true} />
              <AsideMenuItem
                to={asideInstallPath.INSTALL_STATUS}
                title='설치현황'
                hasBullet={true}
              />
              <AsideMenuItem to={asideInstallPath.INSTALL_AS} title='A/S' hasBullet={true} />
            </AsideMenuItemWithSub>
            <div className='menu-item'>
              <div className={'border-top border-2 border-white'} />
            </div>
            <AsideMenuItemWithSub
              to='/charge/*'
              title='요금연계'
              icon='/media/icons/duotune/finance/fin010.svg'
            >
              <AsideMenuItem to={asideChargePath.CHARGE_INFO} title='요금연계' hasBullet={true} />
              <AsideMenuItem to={asideChargePath.CHARGE_SETTING} title='설정' hasBullet={true} />
            </AsideMenuItemWithSub>
          </>
        )
      case 'sys_user':
        return (
          <>
            <AsideMenuItemWithSub
              to='/customer/*'
              title='수용가'
              icon='/media/icons/duotune/general/gen001.svg'
            >
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_REGISTER}
                title='수용가 등록 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_ALLOCATION}
                title='수용가 할당 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_INFO}
                title='수용가 정보관리 '
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_BINARY_CHECK}
                title='검침 이미지 검증'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_FLAGGED_REVIEW}
                title='확인 필요 수용가'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_ACTIVITY}
                title='건강 모니터링 '
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CHECKLIST}
                title='수용가 검침조회'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CHECK_REPORT}
                title='검침 리포트'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_MINIMUM_FLOW}
                title='최소유량 조회'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_STATUS}
                title='수용가 현황'
                hasBullet={true}
              />
              <AsideMenuItem to={asideCustomerPath.CUSTOMER_HDM} title='HDM' hasBullet={true} />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_LEAKAGE}
                title='누수의심 조회'
                hasBullet={true}
              />
              {leakModelHandler(serverLocalName, officeInfo.value) === '2' && (
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_UNUSED}
                  title='장기미사용 조회'
                  hasBullet={true}
                />
              )}
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_FREEZE_WARNING}
                title='동파위험 조회'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/device/*'
              title='단말기'
              icon='/media/icons/duotune/electronics/elc003.svg'
            >
              <AsideMenuItem
                to={asideDevicePath.DEVICE_REGISTER}
                title='단말기 등록 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_ALLOCATION}
                title='단말기 검수/할당 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_INFO}
                title='단말기 정보 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_IMAGES}
                title='단말기 수신영상 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_HISTORY}
                title='단말기 HISTORY'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/task/*'
              title='업무'
              icon='/media/icons/duotune/files/fil002.svg'
            >
              <AsideMenuItem to={asideTaskPath.TASK_AS} title='AS 관리' hasBullet={true} />
              <AsideMenuItem to={asideTaskPath.TASK_RECOVERY} title='회수 조회' hasBullet={true} />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/account/*'
              title='계정관리'
              icon='/media/icons/duotune/communication/com006.svg'
            >
              <AsideMenuItem
                to={asideAccountPath.ACCOUNT_GROUP}
                title='사용자 계정관리'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/system/*'
              title='시스템'
              icon='/media/icons/duotune/coding/cod001.svg'
            >
              <AsideMenuItem
                to={asideSystemPath.SYSTEM_CODE}
                title='시스템 코드관리'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/settings/*'
              title='설정'
              icon='/media/icons/duotune/general/gen003.svg'
            >
              <AsideMenuItem
                to={asideSettingsPath.SETTINGS_SETUP}
                title='사업소 기초설정'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/install/*'
              title='설치자 관리'
              icon='/media/icons/duotune/coding/cod009.svg'
            >
              <AsideMenuItem to={asideInstallPath.INSTALL_CONNECT} title='설치' hasBullet={true} />
              <AsideMenuItem
                to={asideInstallPath.INSTALL_STATUS}
                title='설치현황'
                hasBullet={true}
              />
              <AsideMenuItem to={asideInstallPath.INSTALL_AS} title='A/S' hasBullet={true} />
            </AsideMenuItemWithSub>

            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'></span>
              </div>
            </div>
          </>
        )
      case 'gov_admin':
        return (
          <>
            <AsideMenuItemWithSub
              to='/customer/*'
              title='수용가'
              icon='/media/icons/duotune/general/gen001.svg'
            >
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_STATUS}
                title='수용가 현황'
                hasBullet={true}
              />
              {isShowHdmMenu && (
                <AsideMenuItem to={asideCustomerPath.CUSTOMER_HDM} title='HDM' hasBullet={true} />
              )}
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_ACTIVITY}
                title='건강 모니터링'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CHECKLIST}
                title='수용가 검침조회'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CHECK_REPORT}
                title='검침 리포트'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_LEAKAGE}
                title='누수의심 조회'
                hasBullet={true}
              />
              {leakModelHandler(serverLocalName, officeInfo.value) === '2' && (
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_UNUSED}
                  title='장기미사용 조회'
                  hasBullet={true}
                />
              )}
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_MINIMUM_FLOW}
                title='최소유량 조회'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_FREEZE_WARNING}
                title='동파위험 조회'
                hasBullet={true}
              />
              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-8 ls-1'></span>
                </div>
              </div>
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/settings/*'
              title='설정'
              icon='/media/icons/duotune/general/gen003.svg'
            >
              <AsideMenuItem
                to={asideSettingsPath.SETTINGS_SETUP}
                title='사업소 기초설정'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>

            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'></span>
              </div>
            </div>
          </>
        )
      case 'charge_user':
        if (chargeUserHandler(serverLocalName, officeInfo?.value)) {
          return (
            <>
              <AsideMenuItemWithSub
                to='/customer/*'
                title='수용가'
                icon='/media/icons/duotune/general/gen001.svg'
              >
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_CUSTOMER_STATUS}
                  title='수용가 현황'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_ACTIVITY}
                  title='건강 모니터링'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_CHECKLIST}
                  title='수용가 검침조회'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_CHECK_REPORT}
                  title='검침 리포트'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_CUSTOMER_LEAKAGE}
                  title='누수의심 조회'
                  hasBullet={true}
                />
                {leakModelHandler(serverLocalName, officeInfo.value) === '2' && (
                  <AsideMenuItem
                    to={asideCustomerPath.CUSTOMER_UNUSED}
                    title='장기미사용 조회'
                    hasBullet={true}
                  />
                )}
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_MINIMUM_FLOW}
                  title='최소유량 조회'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_FREEZE_WARNING}
                  title='동파위험 조회'
                  hasBullet={true}
                />
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'></span>
                  </div>
                </div>
              </AsideMenuItemWithSub>

              <AsideMenuItemWithSub
                to='/settings/*'
                title='설정'
                icon='/media/icons/duotune/general/gen003.svg'
              >
                <AsideMenuItem
                  to={asideSettingsPath.SETTINGS_SETUP}
                  title='사업소 기초설정'
                  hasBullet={true}
                />
              </AsideMenuItemWithSub>

              <div className='menu-item'>
                <div className={'border-top border-2 border-white'} />
              </div>
              <AsideMenuItemWithSub
                to='/charge/*'
                title='요금연계'
                icon='/media/icons/duotune/finance/fin010.svg'
              >
                <AsideMenuItem to={asideChargePath.CHARGE_INFO} title='요금연계' hasBullet={true} />
              </AsideMenuItemWithSub>
            </>
          )
        } else {
          return (
            <>
              <div className='menu-item'>
                <div className={'border-top border-2 border-white'} />
              </div>
              <AsideMenuItemWithSub
                to='/charge/*'
                title='요금연계'
                icon='/media/icons/duotune/finance/fin010.svg'
              >
                <AsideMenuItem to={asideChargePath.CHARGE_INFO} title='요금연계' hasBullet={true} />
              </AsideMenuItemWithSub>
            </>
          )
        }
      case 'installer':
        return (
          <>
            <AsideMenuItemWithSub
              to='/install/*'
              title='설치자 관리'
              icon='/media/icons/duotune/coding/cod009.svg'
            >
              <AsideMenuItem to={asideInstallPath.INSTALL_CONNECT} title='설치' hasBullet={true} />
              <AsideMenuItem
                to={asideInstallPath.INSTALL_STATUS}
                title='설치 완료'
                hasBullet={true}
              />
              <AsideMenuItem to={asideInstallPath.INSTALL_AS} title='A/S' hasBullet={true} />
              <AsideMenuItem
                to={asideInstallPath.INSTALL_AS_COMPLETE}
                title='A/S 완료'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
          </>
        )

      case 'inspector':
        return (
          <>
            <AsideMenuItemWithSub
              to='/device/*'
              title='단말기'
              icon='/media/icons/duotune/electronics/elc003.svg'
            >
              <AsideMenuItem
                to={asideDevicePath.DEVICE_REGISTER}
                title='단말기 등록 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_ALLOCATION}
                title='단말기 검수/할당 관리'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideDevicePath.DEVICE_INFO}
                title='단말기 정보 관리'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
          </>
        )

      case 'gov_user':
        return (
          <>
            <AsideMenuItemWithSub
              to='/device/*'
              title='단말기'
              icon='/media/icons/duotune/electronics/elc003.svg'
            >
              <AsideMenuItem
                to={asideDevicePath.DEVICE_INFO}
                title='단말기 정보 관리'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
          </>
        )

      case 'customer_client':
        return (
          <>
            <AsideMenuItem to={asideCustomerPath.CUSTOMER_CLIENT} title='수용가' hasBullet={true} />
          </>
        )
      case 'gov_meterman':
      case 'gov_meterman_editable':
      case 'gov_coop':
      case 'manu_cust':
        return (
          <>
            <AsideMenuItemWithSub
              to='/customer/*'
              title='수용가'
              icon='/media/icons/duotune/general/gen001.svg'
            >
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_STATUS}
                title='수용가 현황'
                hasBullet={true}
              />

              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-8 ls-1'></span>
                </div>
              </div>
            </AsideMenuItemWithSub>
          </>
        )
      case 'gov_charge':
        return (
          <>
            <AsideMenuItemWithSub
              to='/customer/*'
              title='수용가'
              icon='/media/icons/duotune/general/gen001.svg'
            >
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_STATUS}
                title='수용가 현황'
                hasBullet={true}
              />
              {isShowHdmMenu && (
                <AsideMenuItem to={asideCustomerPath.CUSTOMER_HDM} title='HDM' hasBullet={true} />
              )}
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_ACTIVITY}
                title='건강 모니터링'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CHECKLIST}
                title='수용가 검침조회'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CHECK_REPORT}
                title='검침 리포트'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_LEAKAGE}
                title='누수의심 조회'
                hasBullet={true}
              />
              {leakModelHandler(serverLocalName, officeInfo.value) === '2' && (
                <AsideMenuItem
                  to={asideCustomerPath.CUSTOMER_UNUSED}
                  title='장기미사용 조회'
                  hasBullet={true}
                />
              )}
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_MINIMUM_FLOW}
                title='최소유량 조회'
                hasBullet={true}
              />
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_FREEZE_WARNING}
                title='동파위험 조회'
                hasBullet={true}
              />
              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-8 ls-1'></span>
                </div>
              </div>
            </AsideMenuItemWithSub>

            <AsideMenuItemWithSub
              to='/settings/*'
              title='설정'
              icon='/media/icons/duotune/general/gen003.svg'
            >
              <AsideMenuItem
                to={asideSettingsPath.SETTINGS_SETUP}
                title='사업소 기초설정'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>

            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'></span>
              </div>
            </div>

            <div className='menu-item'>
              <div className={'border-top border-2 border-white'} />
            </div>
            <AsideMenuItemWithSub
              to='/charge/*'
              title='요금연계'
              icon='/media/icons/duotune/finance/fin010.svg'
            >
              <AsideMenuItem to={asideChargePath.CHARGE_INFO} title='요금연계' hasBullet={true} />
            </AsideMenuItemWithSub>
          </>
        )

      default:
        return (
          <>
            <AsideMenuItemWithSub
              to='/customer/*'
              title='수용가'
              icon='/media/icons/duotune/general/gen001.svg'
            >
              <AsideMenuItem
                to={asideCustomerPath.CUSTOMER_CUSTOMER_STATUS}
                title='수용가 현황'
                hasBullet={true}
              />

              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-8 ls-1'></span>
                </div>
              </div>
            </AsideMenuItemWithSub>
          </>
        )
    }
  }

  // 모바일: sys 계정(sys_admin/sys_user)이 아니면 '수용가 현황' 한 페이지만 노출
  const mobileCustomerStatusOnlyMenu = (
    <AsideMenuItemWithSub
      to='/customer/*'
      title='수용가'
      icon='/media/icons/duotune/general/gen001.svg'
    >
      <AsideMenuItem
        to={asideCustomerPath.CUSTOMER_CUSTOMER_STATUS}
        title='수용가 현황'
        hasBullet={true}
      />
    </AsideMenuItemWithSub>
  )

  const accountType = userInfo?.accountType
  const isSysAccount = String(accountType).includes('sys')
  // 원래 '수용가 현황' 메뉴가 없던 계정은 모바일 제한에서 제외하고 기존 메뉴 유지
  const noStatusAccounts = ['installer', 'inspector', 'gov_user', 'customer_client']
  const isChargeUserWithoutStatus =
    accountType === 'charge_user' && !chargeUserHandler(serverLocalName, officeInfo?.value)
  const hasNoStatusAccess = noStatusAccounts.includes(accountType) || isChargeUserWithoutStatus

  const applyMobileStatusOnly = isMobile && !isSysAccount && !hasNoStatusAccess

  return (
    <>
      {officeInfo && (
        <div>
          {applyMobileStatusOnly
            ? mobileCustomerStatusOnlyMenu
            : aSideMenuHandler(accountType)}
        </div>
      )}
    </>
  )
}
